export var UserRole;
(function (UserRole) {
    UserRole["USER"] = "USER";
    UserRole["CLIENT"] = "CLIENT";
    UserRole["MODERATOR"] = "MODERATOR";
    UserRole["ANALYST"] = "ANALYST";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
})(UserRole || (UserRole = {}));
